import ContactDetails from '../components/ContactDetails';
import ContactForm from '../components/ContactForm';
import CtaBand from '../components/CtaBand';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import ContactMapVisual from '../components/illustrations/ContactMapVisual';
import { SITE } from '../config/site';

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact"
        description={`Contact ${SITE.legalName} — ${SITE.phoneDisplay}, ${SITE.email}, ${SITE.location}.`}
        path="/contact"
      />

      <PageHero
        label="Contact"
        title="Speak with our team"
        tagline={SITE.domain}
        lead={`Product demos, partnerships, and custom engagements — we respond on business days (${SITE.businessHours}).`}
      />

      <section className="section section--band">
        <div className="container contact-grid contact-grid--form">
          <div className="card card--glass">
            <h3>Send a message</h3>
            <ContactForm showProductSelect submitLabel="Send message" />
          </div>
          <div className="card card--glass contact-card">
            <ContactDetails />
            <div className="contact-map-wrap">
              <ContactMapVisual />
            </div>
            <p className="contact-card__note">{SITE.legalName}</p>
          </div>
        </div>
      </section>

      <CtaBand
        creative
        title="Prefer a product walkthrough?"
        description="Book a demo for SutraMQ, SutraACS, or MGOpen NMS."
        primaryLabel="Request a demo"
        primaryHref="/demo"
        primaryExternal={false}
        secondaryLabel="View products"
        secondaryTo="/products"
      />
    </>
  );
}
